import { Card, CardContent } from "@/components/ui/v2/card";
import { Skeleton } from "@/components/ui/v2/skeleton";

export function InfoItemSkeleton() {
  return (
    <Card padding="xs">
      <CardContent className="flex items-center gap-4 px-5 py-4">
        <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
        <div className="space-y-1.5">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-4 w-32" />
        </div>
      </CardContent>
    </Card>
  );
}
